import el from "@cypherpotato/el";
import { TagsInput } from "./form";
import { Link } from "./link";
import { MutedText } from "./text";
import { BadgeList } from "./badge";
import { Section } from "./layout";
import { Button } from "./button";
import { Icon } from "./icon";
import { showFlyout } from "../ui/flyout";

export function ToolNamePicker(name, { value = [] }) {

    const tools = el.state.create(value);

    function addSelf(newData) {
        var set = new Set([...tools.value, ...newData]);
        var arr = Array.from(set);
        arr.sort();
        tools.value = arr;
    }

    return el("div.tool-name-picker[form-slot]",
        {
            name,
            id: name,
            $properties: {
                value: {
                    get() {
                        return tools.value;
                    },
                    set(value) {
                        tools.value = value;
                    }
                }
            }
        },
        el.state.listening([tools], () => TagsInput("skill-tools", {
            value: tools.value,
            onChange(newValue) {
                tools.value = newValue;
            }
        })),
        el("div.tools-hints-pane",
            BadgeList(
                Button(Icon("link"), "Open URLs", {
                    onClick() {
                        addSelf(["open_url"]);
                    }
                }),
                Button(Icon("search-line"), "Web search", {
                    onClick() {
                        addSelf(["web_search"]);
                    }
                }),
                Button(Icon("twitter-x-line"), "X Tools", {
                    onClick() {
                        addSelf(["x_posts_search", "x_view_post"]);
                    }
                }),
                Button(Icon("drag-drop-line"), "Advanced web search", {
                    onClick() {
                        addSelf(["advanced_web_search"]);
                    }
                }),
                Button(Icon("braces-line"), "Code execution", {
                    onClick() {
                        addSelf(["evaluate_code"]);
                    }
                }),
                Button(Icon("mail-send-line"), "Advanced Request", {
                    onClick() {
                        addSelf(["request"]);
                    }
                }),
                Button(Icon("image-ai-line"), "Image Generation", {
                    onClick() {
                        addSelf(["generate_image"]);
                    }
                }),
                Button(Icon("brain-2-line"), "Remember", {
                    onClick() {
                        addSelf(["memory_search", "memory_save"]);
                    }
                }),
                Button(Icon("time-line"), "Current date and time", {
                    onClick() {
                        addSelf(["get_date_time"]);
                    }
                }),
                Button(Icon("file-paper-2-line"), "Generate document", {
                    onClick() {
                        addSelf(["generate_document"]);
                    }
                }),
                Button(Icon("code-s-slash-line"), "Generate web page", {
                    onClick() {
                        addSelf(["generate_web_page"]);
                    }
                }),
            )
        )
    );
}